module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-hocker-01.9f229299.jpeg";